import { useEffect, useState } from "react";
import { toast } from "sonner";

import { api } from "@/api";
import { Multi, errText } from "@/components/prospect/common";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const EMPTY_RULE = { name: "", regions: [], departments: [], categories: [], squids: [], size: 5000, tags: [], active: true };

export function RuleFields({ value, set, meta }) {
  return (
    <div className="ps-form">
      <label>Régions ciblées<Multi options={meta.regions} value={value.regions} onChange={(regions) => set({ regions })} testid="rule-regions" /></label>
      <label>Départements (codes, séparés par des virgules)<input className="pl-select" value={value.departments.join(", ")} onChange={(e) => set({ departments: e.target.value.split(",").map((x) => x.trim().toUpperCase()).filter(Boolean) })} placeholder="Ex. 35, 56" data-testid="rule-departments" /></label>
      <label>Catégories / activités<Multi options={meta.categories} value={value.categories} onChange={(categories) => set({ categories })} testid="rule-categories" placeholder="Aucune catégorie importée" /></label>
      <div className="ps-row">
        <label>Taille du fichier<input type="number" min={10} className="pl-select" value={value.size} onChange={(e) => set({ size: Number(e.target.value) })} data-testid="rule-size" /></label>
        <label>Tags (séparés par des virgules)<input className="pl-select" value={value.tags.join(", ")} onChange={(e) => set({ tags: e.target.value.split(",").map((x) => x.trim()).filter(Boolean) })} data-testid="rule-tags" /></label>
      </div>
    </div>
  );
}

export function NewFileDialog({ onClose, onCreated }) {
  const [meta, setMeta] = useState(null);
  const [form, setForm] = useState({ ...EMPTY_RULE, agent_id: "" });
  const [busy, setBusy] = useState(false);
  const set = (p) => setForm((f) => ({ ...f, ...p }));
  useEffect(() => {
    Promise.all([api.get("/prospect/settings"), api.get("/prospect/contacts/stats")]).then(([s, st]) => {
      setMeta({ regions: s.data.regions, agents: s.data.agents, categories: st.data.categories.map((c) => c._id).filter(Boolean) });
      set({ tags: s.data.default_tags || [] });
    }).catch((e) => toast.error(errText(e)));
  }, []);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { const { data } = await api.post("/prospect/files", { ...form, agent_id: form.agent_id || null }); toast.success(`Fichier « ${data.name} » créé avec ${data.added} contacts.`); onCreated(); } catch (err) { toast.error(errText(err)); } finally { setBusy(false); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="ps-dialog" data-testid="new-file-dialog">
        <DialogHeader><DialogTitle>Créer un fichier de prospection</DialogTitle></DialogHeader>
        {meta && (
          <form onSubmit={submit} className="ps-form">
            <label>Nom (laisser vide pour un nom automatique)<input className="pl-select" value={form.name} onChange={(e) => set({ name: e.target.value })} data-testid="new-file-name" /></label>
            <RuleFields value={form} set={set} meta={meta} />
            <label>Agent assigné<select className="pl-select" value={form.agent_id} onChange={(e) => set({ agent_id: e.target.value })} data-testid="new-file-agent"><option value="">Non assigné</option>{meta.agents.map((a) => <option key={a.id} value={a.id}>{a.name}</option>)}</select></label>
            <div className="ps-foot"><button type="button" className="secondary-button" onClick={onClose}>Annuler</button><button type="submit" className="primary-button" disabled={busy} data-testid="new-file-submit">{busy ? "Création…" : "Créer le fichier"}</button></div>
          </form>
        )}
      </DialogContent>
    </Dialog>
  );
}
